import { render, staticRenderFns } from "./wishInfoHandle.vue?vue&type=template&id=5b9c596a&scoped=true&"
import script from "./wishInfoHandle.vue?vue&type=script&lang=js&"
export * from "./wishInfoHandle.vue?vue&type=script&lang=js&"
import style0 from "./wishInfoHandle.vue?vue&type=style&index=0&id=5b9c596a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9c596a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9c596a')) {
      api.createRecord('5b9c596a', component.options)
    } else {
      api.reload('5b9c596a', component.options)
    }
    module.hot.accept("./wishInfoHandle.vue?vue&type=template&id=5b9c596a&scoped=true&", function () {
      api.rerender('5b9c596a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fude/wish/wishInfoHandle.vue"
export default component.exports